import type { PaginatedResponse } from '@/types/api'
import { disabledFill, focusRing, quietFill } from '@/components/ui/buttonStyles'

interface PaginationProps {
  meta: PaginatedResponse<unknown>['meta'] | null
  onPageChange: (page: number) => void
}

export function Pagination({ meta, onPageChange }: PaginationProps) {
  if (!meta || meta.total_pages <= 1) return null

  const start = (meta.current_page - 1) * meta.per_page + 1
  const end = Math.min(meta.current_page * meta.per_page, meta.total_count)

  return (
    <div className="flex items-center justify-between pt-4 text-sm font-light text-muted">
      <span>
        {start}–{end} of {meta.total_count}
      </span>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(meta.current_page - 1)}
          disabled={meta.current_page <= 1}
          className={`min-h-11 rounded-md px-3 transition-colors duration-150 ${quietFill} ${disabledFill} ${focusRing}`}
        >
          Previous
        </button>
        <button
          onClick={() => onPageChange(meta.current_page + 1)}
          disabled={meta.current_page >= meta.total_pages}
          className={`min-h-11 rounded-md px-3 transition-colors duration-150 ${quietFill} ${disabledFill} ${focusRing}`}
        >
          Next
        </button>
      </div>
    </div>
  )
}
